export enum PurchaseType {
    Unknown = 0,
    SelfPurchased = 1,
    SelfPurchasedAutoVerified = 2,
    AutoPurchased = 3,
}
export default PurchaseType;
